import { Table, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const customers = [
  { id: 'c1', name: 'Jane Doe', email: 'jane@example.com', totalOrders: 12, totalSpent: 1240 },
  { id: 'c2', name: 'John Smith', email: 'john@example.com', totalOrders: 7, totalSpent: 580 },
];

export default function Customers() {
  return (
    <>
      <Row className="mb-3">
        <Col>
          <h3>Customers</h3>
        </Col>
      </Row>
      <Table hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Total Orders</th>
            <th>Total Spent</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer) => (
            <tr key={customer.id}>
              <td>
                <Link to={`/customers/${customer.id}`}>{customer.name}</Link>
              </td>
              <td>{customer.email}</td>
              <td>{customer.totalOrders}</td>
              <td>${customer.totalSpent}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
}

